import { Link } from 'react-router-dom';
import RemodelCategories from '../data/RemodelCategories.json';
import { Helmet } from 'react-helmet-async';

export default function FeaturedServices() {
  // Helper to ensure Cloudinary URLs
  const getCloudinaryUrl = (url) =>
    url.startsWith('http')
      ? url
      : `https://res.cloudinary.com/dwoubdppz/image/upload${url}`;

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Featured Remodeling Services | Oak & Stone Remodel</title>
        <meta
          name="description"
          content="Explore our most popular remodeling services in Utah, including kitchen remodels, bathroom renovations, custom cabinets, woodwork, and full house transformations. Discover what sets Oak & Stone apart!"
        />
      </Helmet>
      <div className="relative h-[40vh] w-full flex items-center justify-center mb-10">
        <img
          src="https://res.cloudinary.com/dwoubdppz/image/upload/v1751597871/oak-and-stone-remodel/landing/services.webp"
          alt="Featured Remodeling Services"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />
        <div className="absolute inset-0 bg-black/60 z-10" />
        <div className="relative z-20 px-4 mx-auto max-w-2xl text-center text-white">
          <h1 className="mb-3 text-4xl font-bold tracking-wide uppercase drop-shadow-lg md:text-5xl">
            Featured Remodeling Services
          </h1>
          <p className="mb-4 text-lg font-medium drop-shadow">
            Discover our most requested home remodeling services in Utah. From
            stunning kitchens and spa-like bathrooms to custom cabinetry and
            full house renovations, Oak & Stone delivers quality, craftsmanship,
            and lasting value.
          </p>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-4 pb-16">
        <section className="mb-10 text-center">
          <h2 className="text-2xl font-bold mb-4 text-gray-900">
            Choose Your Remodeling Project
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Whether you’re dreaming of a modern kitchen, a luxurious bathroom,
            or custom woodwork, our team has the expertise to bring your vision
            to life. Explore each service to learn more about our process, see
            project galleries, and discover what sets Oak & Stone apart from
            other Utah remodelers.
          </p>
        </section>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {RemodelCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/featured/${cat.slug}`}
              className="group block bg-white rounded-lg shadow hover:shadow-lg transition overflow-hidden border border-gray-100 hover:border-blue-200">
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={getCloudinaryUrl(cat.featuredImage)}
                  alt={cat.name}
                  className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4 z-10">
                  <h3 className="text-xl font-semibold text-white drop-shadow mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-white/90 drop-shadow line-clamp-2">
                    {cat.shortDescription}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
